<template>
  <span class="version">v{{ appVersion }}</span>
</template>

<script>
/* eslint-disable no-restricted-globals */

export default {
  data() {
    return {
      timer: undefined,
    };
  },
  computed: {
    appVersion() {
      return process.env.PACKAGE_VERSION.version;
    },
    appUrl() {
      return process.env.VUE_APP_APPURL;
    },
  },
  async created() {
    console.log(this.appVersion);
    this.checkVersion();
    this.timer = setInterval(this.checkVersion, 180000);
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    async checkVersion() {
      try {
        const version = JSON.parse(await this.query('GET', `${this.appUrl}/version.json`));
        console.log(version.version);
        if (version.version !== this.appVersion) {
          // eslint-disable-next-line no-alert
          const r = confirm('An update is available, please click ok to load the latest version');
          if (r === true) {
            window.location.reload();
          } else {
            clearInterval(this.timer);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    query(method, url) {
      return new Promise(((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open(method, url);
        xhr.onload = () => {
          if (this.status >= 200 && this.status < 300) {
            resolve(xhr.response);
          } else {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({
              status: this.status,
              statusText: xhr.statusText,
            });
          }
        };
        xhr.onerror = () => {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject({
            status: this.status,
            statusText: xhr.statusText,
          });
        };
        xhr.send();
      }));
    },
  },
};
</script>

<style lang="css" scoped>
.version {
  position: absolute;
  color: #ccde9d;
  bottom: 0;
  left: 5%;
  font-size: x-small;
}
</style>
